import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { createQueryClient } from "./api/queries";
import { LocaleProvider } from "./i18n/locale";
import { createAppRouter, handleMutationError, handleQueryError } from "./router";
import { browserTabStorage } from "./session/tab-context";
import { BrowserPhoneProvider } from "./telephony/call-session";
import { twilioPhone } from "./telephony/twilio-phone";
import "@fontsource-variable/plus-jakarta-sans";
import "./design/design-tokens.css";
import "./design/base.css";

// Una cache e un router per scheda del browser; l'azienda della scheda vive nel suo `sessionStorage` (D1).
// Il telefono del browser è quello di Twilio (piano M4, D10), con il SDK scaricato in sottofondo appena il guscio di chi chiama
// è pronto (resta fuori dal pacchetto iniziale); i test montano l'applicazione con quello finto (`test/app-harness.tsx`).
// Gli errori delle query arrivano soltanto dopo il primo caricamento del router, quindi a router pronto.
const queryClient = createQueryClient({
  onQueryError: (error, queryKey) => handleQueryError(router, error, queryKey),
  onMutationError: (error) => handleMutationError(router, error),
});
const router = createAppRouter({ queryClient, tabStorage: browserTabStorage() });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <LocaleProvider>
        <BrowserPhoneProvider phone={twilioPhone}>
          <RouterProvider router={router} />
        </BrowserPhoneProvider>
      </LocaleProvider>
    </QueryClientProvider>
  </StrictMode>,
);
